export const DEFAULT_PHONE_COUNTRY_CODE = "+55" as const

/**
 * Get the default phone country code based on locale
 */
export function getDefaultCountryCodeByLocale(locale: string): PhoneCountryCode {
  const normalizedLocale = locale.toLowerCase()
  if (normalizedLocale === 'en-us' || normalizedLocale === 'en') {
    return "+1"
  }
  return "+55" // Default to Brazil for pt-BR and other locales
}

export const PHONE_COUNTRIES = [
  {
    code: "+55",
    label: "Brazil",
    flagSrc: "/flags/br.svg",
    flagAlt: "Brazil",
  },
  {
    code: "+1",
    label: "United States",
    flagSrc: "/flags/us.svg",
    flagAlt: "United States",
  },
] as const

export type PhoneCountryCode = (typeof PHONE_COUNTRIES)[number]["code"]

const COUNTRY_CODE_PATTERN = /^\s*(?:\(\+(55|1)\)|\+(55|1))/

export function splitPhoneNumber(
  value: string,
  fallback: PhoneCountryCode = DEFAULT_PHONE_COUNTRY_CODE
): {
  countryCode: PhoneCountryCode
  localNumber: string
  detected: boolean
} {
  if (!value) {
    return { countryCode: fallback, localNumber: "", detected: false }
  }

  const match = value.match(COUNTRY_CODE_PATTERN)
  if (!match) {
    return { countryCode: fallback, localNumber: value, detected: false }
  }

  const codeDigits = match[1] ?? match[2]
  const countryCode = `+${codeDigits}` as PhoneCountryCode
  const localNumber = value
    .slice(match[0].length)
    .replace(/^[^\d]+/, "")
    .trim()

  return { countryCode, localNumber, detected: true }
}
